import styled from 'styled-components';

const StyledSubscriptionSnippet = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  
  padding: 2px 0;
  
  a {
    color: ${props => props.theme.colors.neutral_10};
    
    .ant-space-item {
      display: flex;
      
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_6};
        }
      }
    }
    
    &:hover {
      color: #1677ff;
    }
  }
`;


export {
  StyledSubscriptionSnippet,
}